export default "__VITE_ASSET__2a31a061__"